import React, { useEffect } from "react";
import "./App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import MenuSection from "./components/MenuSection";
import DeliverySection from "./components/DeliverySection";
import GallerySection from "./components/GallerySection";
import LocationSection from "./components/LocationSection";
import HoursSection from "./components/HoursSection";
import SocialSection from "./components/SocialSection";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    // Scroll reveal animation
    const reveals = document.querySelectorAll('.reveal');
    
    const revealOnScroll = () => {
      reveals.forEach((el) => {
        const windowHeight = window.innerHeight;
        const elementTop = el.getBoundingClientRect().top;
        const revealPoint = 150;

        if (elementTop < windowHeight - revealPoint) {
          el.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', revealOnScroll);
    revealOnScroll(); // Check on load

    return () => window.removeEventListener('scroll', revealOnScroll);
  }, []);

  return (
    <div className="App min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <MenuSection />
        <DeliverySection />
        <GallerySection />
        <LocationSection />
        <HoursSection />
        <SocialSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
